if (!customElements.get('image-cards')) {
  customElements.define(
    'image-cards',
    class ImageCards extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.image-cards__inner',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.sectionEl = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.controls = this.sectionEl.querySelector('.swiper-controls');
        this.pagination = this.sectionEl.querySelector('.swiper-pagination-wrapper');

        this.enableSliderDesktop = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.enableDragScroll = this.dataset.enableDragScroll === 'true';
        this.galleryMode = this.dataset.galleryMode === 'true';
        this.totalSlides = parseInt(this.dataset.totalSlides) || 0;

        this.sliderInstance = false;

        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        if (typeof this.mql.addEventListener === 'function') {
          this.mql.addEventListener('change', this.init.bind(this));
        } else {
          this.mql.onchange = () => this.init();
        }
        this.init();
      }

      toggleControls(hide = true) {
        if (this.controls) this.controls.style.display = hide ? 'none' : '';
        if (this.pagination) this.pagination.style.display = hide ? 'none' : '';
      }  

      init() {
        const isMobile = !!(this.mql && this.mql.matches);

        if (isMobile) {
          this.initSlider();
          this.toggleControls(false);
          return;
        }
        if (!this.enableSliderDesktop) {
          this.destroySlider();
          this.toggleControls(true);
        } else {
          this.initSlider();
          this.toggleControls(false);
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        const shouldLoop = this.totalSlides > 2 && this.totalSlides < 5;

        this.sliderOptions = {
          slidesPerView: this.galleryMode ? 'auto' : 1,
          slidesPerGroup: 1,
          spaceBetween: this.galleryMode ? 8 : spaceBetween,
          navigation: {
            nextEl: this.sectionEl.querySelector(this.selectors.nextEl),
            prevEl: this.sectionEl.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.sectionEl.querySelector(this.selectors.pagination),
            type: this.paginationType,
            clickable: true,
            dynamicBullets: false,
          },
          loop: shouldLoop,
          threshold: 2,
          watchSlidesProgress: true,
          simulateTouch: this.enableDragScroll,
          allowTouchMove: this.enableDragScroll,
        };
        if (!this.galleryMode) {
          this.sliderOptions.breakpoints = {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          };
        } else {
          this.sliderOptions.breakpoints = {
            768: {
              slidesPerView: 'auto',
              spaceBetween: spaceBetween,
            },
          };
        }
        if (this.enableDragScroll) {
          this.sliderOptions.mousewheel = {
            enabled: true,
            forceToAxis: true,
          };
        }

        this.classList.add(this.classes.swiper, 'swiper-equal-height');
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        const swiperModules = this.enableDragScroll ? [FoxTheme.Swiper.Mousewheel] : [];
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, swiperModules);
        this.sliderInstance.init();

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
        
        this.classList.remove(this.classes.swiper, 'swiper-equal-height');
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        
        const slides = this.sliderWrapper.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
          slide.classList.remove('swiper-slide');
          slide.style.width = '';
          slide.style.flexShrink = '';
          slide.style.marginRight = '';
          slide.style.marginLeft = '';
          slide.style.height = '';
          slide.style.minWidth = '';
          slide.style.maxWidth = '';
        });
        
        this.toggleControls(true);
      }
    }
  );
}
